import React from 'react'
import SecureMessageAttachment from '../../components/media/SecureMessageAttachment'
import { getChatAttachmentType } from '../../utils/chatAttachmentStore'

export default function Attachment({ message, onOpenImage, onOpen }) {
    const open = onOpen || onOpenImage
    const type = getChatAttachmentType(message)

    return (
        <div className={`attachment-viewer-entry-AO is-${type || 'file'}`}>
            <SecureMessageAttachment
                message={message}
                onOpen={open}
            />
        </div>
    )
}
